import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ConfirmDialog = ({ open, onClose, onConfirm, onCancel, heading, subHeading, saveText, cancelText }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <Box display="flex" alignItems="center" justifyContent="space-between" px={2} pt={2}>
        <Box display="flex" alignItems="center" gap={1}>
          <ErrorOutlineIcon />
          <Typography variant="h6" fontWeight="bold" >
            Confirm
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent sx={{ textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {heading}
        </Typography>
        <Typography fontWeight="bold" color="text.primary">
          {subHeading}

        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'flex-end', px: 3, pb: 2 }}>
        <Button onClick={onCancel} variant="outlined" color="inherit"  >
          {cancelText}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary" >
          {saveText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;